module.exports = __webpack_public_path__ + "img/m2g_how_notice.55b08846.png";